// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 545 ? "intl-polyfill" : chunkId) + "." + {"541":"080d3144","545":"46071a8f"}[chunkId] + ".chunk.js";
};